import type { HubModelArtifact } from '@robovision/hub'
import { JobBaseArtifact } from './JobBaseArtifact'


export class JobModelArtifact extends JobBaseArtifact {
  public static fromDefinition (
    modelArtifact: HubModelArtifact,
  ) {
    return new JobModelArtifact({
      artifactId: modelArtifact.id,
      // defaults: modelArtifact.defaults
      definitionId: modelArtifact.modelDefinition,
      description: modelArtifact.description,
      name: modelArtifact.name,
    })
  }
}
